import 'regenerator-runtime/runtime'
import useBSSLogger from '../hooks/useBSSLogger';
import getapiclient, { getwpclient } from '../lib/ajaxhelper';

const {logger} = useBSSLogger();

const cerca = async (strentity, id) => {
    const {data} = await getapiclient().post(`${strentity}/cerca`, {
        id
    }) 

    const item = data ?? {};

    logger.debug(`${strentity} trovato`, item)

    return item; 
}

const crea = async (strentity, dati) => {
    const {data} = await getapiclient().post(`${strentity}/crea`, {
        elemento: JSON.stringify(dati)
    }) 

    const nuovo = data ?? {};

    logger.debug(`nuovo ${strentity} creato`, nuovo)

    return nuovo; 
}

const cancella = async (strentity, dati) => {
    const {data} = await getapiclient().post(`${strentity}/cancella`, {
        id: JSON.stringify(dati)
    }) 

    const eliminato = data ?? {};

    logger.debug(`${strentity} eliminato`, dati, eliminato)

    return eliminato; 
}

const modifica = async (strentity, dati) => {
    const {data} = await getapiclient().post(`${strentity}/modifica`, {
        elemento: JSON.stringify(dati)
    }) 

    const modificato = data ?? {};

    logger.debug(`${strentity} modificato`, dati, modificato)

    return modificato; 
}

const defaultGridCfg = {
    take: 99999999,
    skip: 0,
    page: 1,
    pageSize: 99999999,
    filter: {},
    sort: {}
}

const grid = async (strentity, cfg = defaultGridCfg, customurl = null) => {

    const url = customurl === null ? `${strentity}/grid` : customurl;

    const {data} = await getapiclient().post(url, {...defaultGridCfg, ...cfg}) 

    const dati = data ?? {};

    logger.debug(`${strentity} griglia`, cfg, dati.total)

    return dati; 
}


export {
    crea,
    cancella,
    modifica,
    cerca,
    grid,
    defaultGridCfg
}
